var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thailand",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 14.978,
    cy: 14.958,
    rx: 14.978,
    ry: 14.958,
    transform: "translate(0.045 0.001)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M29.021,166.957H.932a14.992,14.992,0,0,0,0,10.4h28.09a14.993,14.993,0,0,0,0-10.4Z",
    transform: "translate(0.001 -157.115)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(3.624 0.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M73.292,0A14.95,14.95,0,0,0,61.939,5.2H84.645A14.95,14.95,0,0,0,73.292,0Z",
    transform: "translate(-61.939)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M84.645,422.957H61.939a14.989,14.989,0,0,0,22.706,0Z",
    transform: "translate(-61.939 -398.246)",
    fill: "#d80027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/TH.cc9be06c061fdf308a09746ab2059f19.svg";
export { ForwardRef as ReactComponent };